import snakeCase from 'lodash/snakeCase';

export const sortMessages = (messages) =>
  messages.sort((a, b) => {
    if (a.timestamp < b.timestamp) {
      return -1;
    }
    if (a.timestamp > b.timestamp) {
      return 1;
    }
    return 0;
  });

export const sortConvos = (convos) =>
  convos.sort((a, b) => {
    if (a?.message?.created_at > b?.message?.created_at) {
      return -1;
    }
    if (a?.message?.created_at < b?.message?.created_at) {
      return 1;
    }
    return 0;
  });

export const DEFAULT_TIME_ZONE = 'America/New_York';

export const roles = ['owner', 'captain', 'renter'];

export const ownerFinalEarningsStates = [
  'request_canceled',
  'declined',
  'concluded',
  'disputed',
  'cancelled',
  'expired',
];

export const ownerPotentialEarningsStates = [
  'initialized',
  'pre_approved',
  'pending_tos',
  'payment_held',
  'unverified',
  'approved',
  'aboard',
  'ashore',
];

export const ownerEarnings = (bookingState: string, owner_earning: number, owner_payout: number) => {
  if (ownerFinalEarningsStates.includes(bookingState)) {
    return owner_earning;
  }
  if (ownerPotentialEarningsStates.includes(bookingState)) {
    return owner_payout;
  }
  return owner_payout;
};

export const bookingStatus = (bookingState, captainState, role, stateReadByUser) => snakeCase(stateReadByUser);

export const bookingStatusLegacy = (bookingState, captainState, role) => {
  if (role === 'captain') {
    if (['approved', 'unverified'].includes(bookingState) && captainState === 'pending') {
      return 'ready-to-approve';
    }
    if (['approved', 'unverified'].includes(bookingState) && captainState === 'approved') {
      return 'approved';
    }
    if (bookingState === 'aboard' && ['approved', 'pending'].includes(captainState)) {
      return 'aboard';
    }
    if (['ashore', 'concluded', 'disputed'].includes(bookingState) && ['approved', 'pending'].includes(captainState)) {
      return 'concluded';
    }
    if (bookingState === 'expired' && ['approved', 'pending'].includes(captainState)) {
      return 'expired';
    }
    if (bookingState === 'cancelled' || captainState === 'cancelled') {
      return 'cancelled';
    }
    return bookingState;
  }
  switch (bookingState) {
    case 'initialized':
      return 'inquiry';
    case 'pre_approved':
      return 'pre-approved';
    case 'payment_held':
      return role === 'renter' ? 'pending' : 'ready-to-approve';
    case 'request_canceled':
      return 'request-cancelled';
    case 'pending':
      return role === 'captain' ? 'ready-to-approve' : 'pending';
    default:
      return bookingState;
  }
};

export const bookingCaptainStatus = (bookingState) => {
  switch (bookingState) {
    case 'admin_removed':
      return 'removed';
    case 'renter_removed':
      return 'removed';
    default:
      return bookingState;
  }
};
